import type { AppLifecycleService } from "../types"

export const appLifecycle: AppLifecycleService = {
  subscribeAppState(callback) {
    const handler = () => callback(document.visibilityState === "visible")
    document.addEventListener("visibilitychange", handler)
    return () => document.removeEventListener("visibilitychange", handler)
  },

  // Restoring a result across a process death is an Android activity concept;
  // a discarded browser tab just reloads with nothing held for it.
  subscribeRestoredResult() {
    return () => {}
  },

  // Renderer loss is reported by the native shell, which the web build has none of.
  async consumeCrashReport() {
    return null
  },
}
